import React, { Fragment } from "react";
import HomeEvents from "../components/HomeEvents";
import HomeClubs from "../components/HomeClubs";
import HomeDeals from "../components/HomeDeals";
import Slider from "../components/sliders/BannerHome";
import Head from "next/head";
import axios from "axios";
import { server } from "../config";
import BreakImageContainer from "../components/BreakImageContainer";
import defaultOGImage from '../public/images/mb_main2.webp'
import darkTheme from '../src/theme';
import { Typography } from "@mui/material";
import AllEventTypes from '../components/AllEventTypes'

const homePageContainer = {         
  marginBottom: darkTheme.spacing(0),               
};
      

export const getStaticProps = async function () {
  try {
    let events = [];
    let deals = [];
    let clubs = [];
    let allEventTypes = [];    
  
    let eventsTotal = 0;
    let dealsTotal = 0;
    let clubsTotal = 0;
  
  
    let banners = [];
  
    await axios
      .get(`${server}/api/events/home?start=0&limit=8`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          events = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
    await axios
      .get(`${server}/api/events/homeTotal`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          eventsTotal = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
    await axios
      .get(`${server}/api/deals/home?start=0&limit=4`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          deals = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
    await axios
      .get(`${server}/api/deals/homeTotal`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          dealsTotal = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
    await axios
      .get(`${server}/api/clubs/home?start=0&limit=8`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          clubs = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
    
    await axios
      .get(`${server}/api/clubs/homeTotal`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          clubsTotal = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
  
    await axios
      .get(`${server}/api/banners/home`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {     
        if (response.status == 200) {
          banners = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })
    
    await axios
      .get(`${server}/api/global/allEventTypes`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          allEventTypes = response.data.result;
        }
      })
      .catch(err => {
        console.log(err);
      })      
  
    const schema = `{
      "@context": "https://schema.org",
      "@type": "Organization",
      "founder": "Rajesh Sukamanchi",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@clubr.in",
        "telephone": "+917993793579",
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "opens": "10:00",
          "closes": "19:00"
        }
      },
      "email": "info@clubr.in",
      "foundingLocation": {
        "@type": "Place",
        "name": "Hyderabad, Telangana"
      },
      "legalName": "Clubr Technoligies Private Limited",
      "telephone": "+917993793579",
      "location": {
        "@type": "Place",
        "name": "Clubr Technoligies Private Limited",
        "address": [
          {
            "@type": "PostalAddress",
            "name": "FIIRE, The Don Bosco College of Engineering, Fatorda, Goa 403601"
          },
          {
            "@type": "PostalAddress",
            "name": "Level 3, Aditya Enclave, Venkatagiri, Jubilee Hills, Hyderabad, Telangana 500033"
          }
        ]
      },
      "logo": "https://clubr.in/new-logo.png"
    }`;
  
    return {
      props: { events, deals, clubs, banners, eventsTotal, dealsTotal, clubsTotal, schema, allEventTypes },
      revalidate: 1
    };
  } catch (e) {
    return {notFound: true}
  }
};

function Home(props) {   
  return (
    <Fragment>
      <Head>
        <title>Discover Events in Best Pubs, Nightclubs, Live Music Venues - Clubr</title>
        <meta name="description" content="Discover upcoming live events in the best Pubs, Nightclubs, Breweries and live Music Venues near you and book online tickets & VIP Tables directly from Clubr"></meta>
        <meta property="og:title" content={`Discover Events in Best Pubs, Nightclubs, Live Music Venues - Clubr`}></meta>
        <meta property="og:description" content={`Discover upcoming live events in the best Pubs, Nightclubs, Breweries and live Music Venues near you and book online tickets & VIP Tables directly from Clubr`}></meta>
        <meta property="og:image" content={props.banners ? props.banners[0].img_path : defaultOGImage}></meta>
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clubr" />
        <meta property="og:url" content={`https://clubr.in`} />
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:site" content="@Clubr14"></meta>
        <meta name="twitter:creator" content="@Clubr14"></meta>
        <meta name="twitter:title" content={`Discover Events in Best Pubs, Nightclubs, Live Music Venues - Clubr`}></meta>
        <meta name="twitter:description" content={`Discover upcoming live events in the best Pubs, Nightclubs, Breweries and live Music Venues near you and book online tickets & VIP Tables directly from Clubr`}></meta>
        <meta name="twitter:image" content={props.banners ? props.banners[0].img_path : defaultOGImage}></meta>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: props.schema }}
        />        
      </Head>
      <Typography component="div" sx={homePageContainer} className={"main_sec"}>        
        <Slider data={props.banners} />
        {/* {props.allEventTypes.length > 0 && (
          <AllEventTypes types={props.allEventTypes} />
        )}         */}
        {props.events.length > 0 && (
          <>
            <HomeEvents events={props.events} total={props.eventsTotal} />
            <BreakImageContainer
              title="Host Your Event with Clubr"
              text=""
              buttonText="Know More"
              buttonURL="https://www.clubr.in/contact"
            />
          </>
        )}
        {props.deals.length > 0 && <HomeDeals deals={props.deals} title="Deals" page="home" total={props.dealsTotal}/>}
        {props.clubs.length > 0 && <HomeClubs clubs={props.clubs} total={props.clubsTotal} />}
      </Typography>
    </Fragment>
  );
}
export default Home;
